import { t } from "ttag";

import { getColumnIcon } from "metabase/common/utils/columns";
import type { IconName } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";

import type {
  QueryColumnInfoPopoverProps,
  TableColumnInfoPopoverProps,
} from "../ColumnInfoPopover";
import {
  QueryColumnInfoPopover,
  TableColumnInfoPopover,
} from "../ColumnInfoPopover";
import {
  HoverParent,
  PopoverDefaultIcon,
  PopoverHoverTarget,
} from "../InfoIcon";

export { HoverParent };

type QueryColumnInfoIconProps = QueryColumnInfoPopoverProps & {
  size?: number;
  icon?: IconName;
  color?: ColorName;
};

export function QueryColumnInfoIcon({
  className,
  size,
  icon,
  color,
  ...props
}: QueryColumnInfoIconProps) {
  const { column } = props;

  return (
    <>
      <QueryColumnInfoPopover {...props}>
        <span aria-label={t`More info`}>
          <PopoverDefaultIcon
            className={className}
            name={icon ?? getColumnIcon(column)}
            size={size}
            c={color}
          />
          <PopoverHoverTarget className={className} name="info" size={size} />
        </span>
      </QueryColumnInfoPopover>
    </>
  );
}

QueryColumnInfoIcon.HoverParent = HoverParent;

type TableColumnInfoIconProps = TableColumnInfoPopoverProps & {
  icon: IconName;
  size?: number;
  color?: ColorName;
};

export function TableColumnInfoIcon({
  className,
  field,
  icon,
  size,
  color,
  ...props
}: TableColumnInfoIconProps) {
  return (
    <TableColumnInfoPopover {...props} field={field}>
      <span aria-label={t`More info`}>
        <PopoverDefaultIcon
          className={className}
          name={icon}
          size={size}
          c={color}
        />
        <PopoverHoverTarget className={className} name="info" size={size} />
      </span>
    </TableColumnInfoPopover>
  );
}

TableColumnInfoIcon.HoverParent = HoverParent;
